/*
 * @Author: Vanny
 * @Date: 2019-08-22 19:35:43
 * @LastEditors: Vanny
 * @LastEditTime: 2020-03-23 16:19:39
 * @Description: 工具箱-常用函数
 */
import invariant from 'invariant';
import { getStorage, STORAGE } from './storage';

// 判断是否为 dev 环境
export const isDev = () =>
  process.env.NODE_ENV === 'development' || process.env.API_ENV !== 'development';

// 获取版本号
export const getVersion = () =>
  `v${process.env.VERSION +
    (process.env.NODE_ENV !== 'production' ? '-' + process.env.NODE_ENV : '')}`;

// 样式
export const createPrefixClassnames = (styles: any, prefix: string) => (suffix?: string) =>
  !suffix ? styles[prefix] : styles[`${prefix}-${suffix}`];

// 去掉首尾空格
export const trim = (origin: string) => (origin || '').replace(/(^\s*)|(\s*$)/g, '');

// 去掉所有空格并改为大写
export const formatUpperCase = (origin: string) =>
  trim(origin)
    .replace(' ', '')
    .toUpperCase();

// 转化为驼峰命名
export const convertCamel = (origin: string) =>
  !origin || /[0-9]/.test(origin)
    ? origin
    : origin.replace(/[\_\-](\w)/g, ($0, $1) => $1.toUpperCase());
// 转化为下划线命名
export const inverseCamel = (origin: string) =>
  !origin || /[0-9]/.test(origin)
    ? origin
    : origin.replace(/([A-Z])/g, ($0, $1) => `_${$1.toLowerCase()}`);

// 深拷贝并转化为驼峰命名
export const deepConvertCamel: any = (origin: any, inverse: boolean) => {
  if (!origin || typeof origin !== 'object') {
    return origin;
  }
  return Object.keys(origin).reduce(
    (acc: Record<string, any>, k: string) => (
      (acc[inverse ? inverseCamel(k) : convertCamel(k)] = deepConvertCamel(origin[k], inverse)), acc
    ),
    origin instanceof Array ? [] : {}
  );
};
// 下载
export function download(blob: string, option: { isUrl: boolean; filename: string }) {
  invariant(blob, 'miss file data');

  const { isUrl, filename } = option;

  if (isUrl) window.open(blob, '_blank');
  else {
    const url = window.URL.createObjectURL(blob);

    const aDom = window.document.createElement('a');
    aDom.setAttribute('download', filename || new Date().toLocaleDateString());

    if (typeof aDom.download === 'undefined') aDom.setAttribute('target', '_blank');

    aDom.href = url;
    window.document.body.appendChild(aDom);
    aDom.click();
    window.document.body.removeChild(aDom);
    if (!isUrl) {
      window.URL.revokeObjectURL(blob);
    }
  }
}
// 生成随机数
export const randomString = () => (Math.random() * Date.now() * 10000).toString(16);

export const $t = (key = '', locale: string | Record<string, string>) =>
  key
    .split(',')
    .map((k) => {
      if (typeof locale === 'string') {
        const l = (getStorage(STORAGE.LOCALE.MAP, false) || {})[locale] || {};
        return l[k] || k;
      }
      return (locale || {})[k] || k;
    })
    .join('');
export const $to = (obj: Record<string, string> = {}, locale: Record<string, string> = {}) =>
  Object.keys(obj).reduce(
    (acc, k) => ((acc[locale[k] || $t(k, 'Global')] = obj[k]), acc),
    {} as Record<string, string>
  );
// 该行"XXX"与第 X 行重复
export const getTipRepeat = (title: string, index: string) => {
  const text = $t('upload_tip28', 'Import');
  return text.replace('XXX', title).replace('X', index);
};

export { localeRender } from './render';
